import CmClient from './CmClient';

export default class DeviceCmClient extends CmClient {
    constructor(id, options) {
        super(id, options, 'DeviceCmClient');
    }
}
